if (!customElements.get('featured-collection-pagination')) {
  customElements.define('featured-collection-pagination', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => this.changePage(event));
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async changePage(event) {
      const link = event.target.closest('a[data-page-url]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (this.getAttribute('aria-busy') === 'true') return;

      const section = this.closest('.shopify-section');
      if (!section) {
        window.location.assign(link.href);
        return;
      }

      this.setAttribute('aria-busy', 'true');
      const status = this.querySelector('[data-pagination-status]');
      if (status) status.textContent = status.dataset.loadingText;
      this.controller = new AbortController();

      try {
        const url = new URL(link.dataset.pageUrl, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Collection page unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.getElementById(section.id);
        if (!replacement?.querySelector('.product-grid')) throw new Error('Collection section missing');

        section.replaceWith(replacement);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(replacement);
        const focusTarget = replacement.querySelector('[aria-current="page"]') || replacement.querySelector('.title');
        if (focusTarget) {
          focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
        }
        replacement.scrollIntoView({ block: 'start', behavior: 'instant' });
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(link.href);
      } finally {
        this.removeAttribute('aria-busy');
        if (status) status.textContent = '';
      }
    }
  });
}
